var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.0 14.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plus-i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "plus-i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L8,6 L14,6 L14,8 L8,8 L8,14 L6,14 L6,8 L0,8 L0,6 L6,6 L6,0 L8,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.0 -24.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plus-i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.999999999998636 19.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.0 5.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plus-i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 14,0 14,14 0,14 0,0",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b752cd791910af0335088840f3b32d2a.svg";
export { ForwardRef as ReactComponent };